
import { getAssetItem } from 'src/utils/helpers';
import {Component, Vue} from 'vue-property-decorator';
import TeacherIcon from '../../teacher/TeacherIcon.vue';

@Component({
  components: {TeacherIcon},
  methods: {getAssetItem}
})
export default class NotificationPermissionDeniedModal extends Vue {
  private isGoneToSettings = false;

  get isDisplayed() {
    return this.NotificationController.state.isNotificationPermissionDeniedModalDisplayed;
  }

  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  onVisibilityChange() {
    if (
      !document.hidden &&
      this.isDisplayed &&
      this.isGoneToSettings &&
      this.NotificationController.isNotificationDenied
    ) {
      this.close();
    }
  }

  goToSettings() {
    this.isGoneToSettings = true;
    this.NotificationController.openNotificationAppSettings();
  }

  close() {
    this.NotificationController.closeNotificationPopup(this.isGoneToSettings);
    this.isGoneToSettings = false;
  }
}
